import { ReactNode } from 'react';

import * as K from 'common/constants';

export enum PageAlertVariant {
  INFO = 'info',
  WARNING = 'warning',
  SUCCESS = 'success',
  ERROR = 'error',
}

export type PageAlertConfig = {
  id?: K.PAGE_ALERT_ID; // useful for identifying a particular alert since its content might be updated immutably
  message?: ReactNode | string;
  linkHref?: string;
  linkText?: string;
  heading?: ReactNode | string;
  dismissible?: boolean;
  inProgress?: boolean;
  autoHide?: boolean;
  duration?: number;
  animateClass?: string; // Class to replace how Alert is animated
  containerClassName?: string; // An additional class for the root element of PageAlert
  variant?: PageAlertVariant;
  children?: ReactNode; // This is a useful escape hatch to plug-in custom alert implementation.
};
